export default "__VITE_ASSET__CtAhIsXU__"